import contenttype from '../templates/contenttype';
export default class Staffbyguid {
  constructor(
    profilesdata,
    showpubs,
    displaylist = false,
    showOrgUnits = false
  ) {
    this.profilesdata = profilesdata;
    this.showpubs = showpubs;
    this.displaylist = displaylist;
    this.showOrgUnits = showOrgUnits;
  }
  getstaffcards() {
    function generateAvatar(forename, surname) {
      // Get the first letter of the forename
      const forenameLetter = forename.charAt(0);
      // Get the first letter of the surname
      const surnameLetter = surname.charAt(0);
      // Combine the letters into a string
      const letters = forenameLetter + surnameLetter;
      // Create a canvas element
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // Set the canvas size to 200x200 pixels
      canvas.width = 200;
      canvas.height = 200;

      // Set the background color to dark blue
      ctx.fillStyle = '#011451';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Set the font color to white
      ctx.fillStyle = 'white';

      // Set the font size to 100px
      ctx.font = '100px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      // Write the two letters to the canvas, centred horizontally and vertically
      ctx.fillText(letters, canvas.width / 2, canvas.height / 2);

      // Get the canvas data as a base64 string
      const data = canvas.toDataURL('image/png');

      // Return the base64 string
      return data;
    }
    let contentarr = this.profilesdata.map((person) => {
      if (!this.displaylist) {
        return contenttype.card({
          content: `
                    <ul>
                        <li>${person.jobtitle} ${this.showOrgUnits ? `[${person.orgunit}]` : ``}</li>
                        ${person.email ? `<li><a href="mailto:${person.email}">${person.email}</a></li>` : ''}
                    </ul>
                    ${person.researchinterests != '' ? `<p><strong>Summary of research interests</strong></p><p>${person.researchinterests}</p>` : ''}
                    ${person.publicationsurl && this.showpubs ? contenttype.accordion({ heading: 'Publications', content: `<div id="publication-${this.getenlightenid(person.publicationsurl)}" class="staffbyguid-publications" data-id="${this.getenlightenid(person.publicationsurl)}"></div>` }) : ''}    
                `,
          heading: `${person.title} ${person.forename} ${person.surname}`,
          image: person.imageurl
            ? person.imageurl
            : generateAvatar(person.forename, person.surname),
          link: person.url,
          id: `${person.forename}${person.surname}-card`,
        });
      } else if (this.displaylist) {
        return `<li><a href="${person.url}">${person.title} ${person.forename} ${person.surname}</a></li>`;
      }
    });
    return `${contenttype.standard({
      content: this.displaylist
        ? `<ul class="programme-list ">${contentarr.join('')}</ul>`
        : contentarr.join(''),
      quicklinks: false,
      contentclasses: 'isfullwidth',
    })}`;
  }

  getenlightenid(url) {
    const spliturl = url.split('/');
    return spliturl[spliturl.length - 1].split('.')[0];
  }

  insertpublications() {
    [...document.querySelectorAll('.staffbyguid-publications')].forEach(
      (el) => {
        this.fetchpublications(el);
      }
    );
  }

  async fetchpublications(el) {
    const id = el.dataset.id;
    const proxyurl = `https://www.gla.ac.uk/feeds/staffbyguid/pubs.html?id=${id}`;
    const response = await fetch(proxyurl);
    const data = await response.text();
    el.insertAdjacentHTML('beforeend', data);
    [
      ...el.querySelectorAll(
        '.ep_view_jump, .ep_view_blurb, .ep_view_timestamp'
      ),
    ].forEach((rel) => {
      rel.parentNode.removeChild(rel);
    });
  }
}
